module.exports = __webpack_public_path__ + "static/img/sx.7657c5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sx.png
// module id = 58t6
// module chunks = 0